
<nav>
	<ng-container *ngFor="let facet of chips">
		<app-chip class="button" 
				[chip]="facet"
				[selectable]="false"
			></app-chip>
	</ng-container>
	
</nav>
